module.exports = __webpack_public_path__ + "static/img/xiawujie.daa1945.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xiawujie.png
// module id = AfIJ
// module chunks = 1